import * as React from "react";
import type { SVGProps } from "react";
const SvgMailbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="#746a80"
    viewBox="0 0 42 41"
    {...props}
  >
    <path
      fill={props.color}
      d="M16.5 25.5A1.5 1.5 0 0 1 15 27H7.5a1.5 1.5 0 1 1 0-3H15a1.5 1.5 0 0 1 1.5 1.5M42 18.75V30a3 3 0 0 1-3 3H22.5v6a1.5 1.5 0 1 1-3 0v-6H3a3 3 0 0 1-3-3V18.75A11.263 11.263 0 0 1 11.25 7.5H25.5v-6A1.5 1.5 0 0 1 27 0h6a1.5 1.5 0 0 1 0 3h-4.5v4.5h2.25A11.263 11.263 0 0 1 42 18.75M19.5 30V18.75a8.25 8.25 0 1 0-16.5 0V30zM39 18.75a8.26 8.26 0 0 0-8.25-8.25H28.5V24a1.5 1.5 0 1 1-3 0V10.5h-6.61a11.23 11.23 0 0 1 3.61 8.25V30H39z"
    />
  </svg>
);
export default SvgMailbox;
